import { useMutation } from 'react-query';
import {
  showErrorSnackbar,
  showSuccessSnackbar
} from 'components/shared/Snackbar';
import { MessageActionType } from '../types';
import { updateEmployeeMessageTaskBulk } from 'RestAPIs/employees/messages';

export const useUpdateEmployeeMessageTaskBulk = () => {
  const { mutateAsync, isLoading } = useMutation(
    (variables: {
      taskIds: string[] | number[];
      actionType: MessageActionType;
    }) => updateEmployeeMessageTaskBulk(variables),
    {
      onSuccess: () => showSuccessSnackbar(),
      onError: () => showErrorSnackbar()
    }
  );

  return { mutateAsync, isLoading };
};

export default useUpdateEmployeeMessageTaskBulk;
